import _objectSpread from "@babel/runtime/helpers/objectSpread2";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["src"];
/* eslint-disable @crehana/eslint-plugin/next/no-next-image-component */
import Image from 'next/legacy/image';
import { getImgxUrl } from '@crehana/utils';

/**
 * This CustomImage component handles dynamic images comming from an api request.
 */
import { jsx as _jsx } from "react/jsx-runtime";
var CustomImage = function CustomImage(_ref) {
  var srcProp = _ref.src,
    props = _objectWithoutProperties(_ref, _excluded);
  var customSrc = {
    src: srcProp
  };

  // if (typeof srcProp === 'string' && srcProp.startsWith('https://')) {
  customSrc.loader = function (_ref2) {
    var src = _ref2.src,
      width = _ref2.width,
      quality = _ref2.quality;
    var isGif = src.includes('.gif');
    var fixedSrc = isGif ? src : getImgxUrl(src, {
      auto: 'format',
      w: width,
      q: quality || 75
    });

    // remove the asset prefix cdn from image url
    if (process.env.ASSET_PREFIX_WITH_MF_NAME && src !== null && src !== void 0 && src.includes(process.env.ASSET_PREFIX_WITH_MF_NAME)) {
      fixedSrc = fixedSrc.replace("".concat(process.env.ASSET_PREFIX_WITH_MF_NAME, "/"), '');
    }

    // append the image cdn if it's necessary
    if (process.env.IMAGE_PREFIX_URL && !fixedSrc.startsWith(process.env.IMAGE_PREFIX_URL) && !fixedSrc.startsWith('https')) {
      // log('image src with prefix url', {
      //   srcProp,
      //   src,
      //   width,
      //   quality,
      //   fixedSrc,
      // });
      return "".concat(process.env.IMAGE_PREFIX_URL).concat(fixedSrc.startsWith('/') ? fixedSrc : "/".concat(fixedSrc));
    }

    // log('image src', { srcProp, src, width, quality, fixedSrc });

    return fixedSrc;
  };
  // }
  return /*#__PURE__*/_jsx(Image, _objectSpread(_objectSpread({}, props), customSrc));
};
export default CustomImage;